import { ProfileResource, getReferenceString } from '@medplum/core';
import {
  AppShell,
  Loading,
  NotificationIcon,
  useMedplum,
  useMedplumNavigate,
  useMedplumProfile,
} from '@medplum/react';
import {
  IconChecklist,
  IconClipboardCheck,
  IconClipboardText,
  IconForms,
  IconMail,
  IconRobot,
  IconUser,
  IconUsersGroup,
} from '@tabler/icons-react';
import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Router } from './Router';
import { SignInPage } from './pages/SignInPage';
import { Logo } from './components/Logo';
import { Footer } from './components/Footer';
// import { LandingPage } from './pages/landing';

export function App(): JSX.Element | null {
  const medplum = useMedplum();
  const profile = useMedplumProfile();
  const navigate = useMedplumNavigate();

  if (medplum.isLoading()) {
    return null;
  }

  // Check if we're on the /annotate path
  if (window.location.pathname.startsWith('/annotate')) {
    return null; // Return empty to let the load balancer handle it
  }

  if (!profile) {
    return (
      <Routes>
        {/* <Route path="/" element={<LandingPage />} /> */}
        <Route path="/signin" element={<SignInPage />} />
        <Route path="*" element={<Navigate replace to="/signin" />} />
      </Routes>
    );
  }

  return (
    <AppShell
      logo={<Logo width={24} />}
      menus={[
        {
          title: 'Charts',
          links: [{ icon: <IconUser />, label: 'Patients', href: '/' }],
        },
        {
          title: 'AI Inbox',
          links: [
            { icon: <IconRobot />, label: 'AI Inbox', href: '/inbox' },
          ],
        },
        {
          title: 'Upload Forms',
          links: [
            { icon: <IconClipboardText />, label: 'Upload Questionnaire', href: '/upload/Questionnaire' },
            { icon: <IconForms />, label: 'Upload Questionnaire Response', href: '/upload/QuestionnaireResponse' },
          ],
        },   
        {
          title: 'Create Resources',
          links: [
            { icon: <IconUsersGroup />, label: 'Create Cohort', href: '/create-cohort' },
            { icon: <IconChecklist />, label: 'Create Plan Definition', href: '/PlanDefinition/new' },
          ],
        },     
      ]}
      resourceTypeSearchDisabled={true}
      notifications={
        <>
          <NotificationIcon
            label="Mail"
            resourceType="Communication"
            countCriteria={`recipient=${getReferenceString(profile as ProfileResource)}&status:not=completed&_summary=count`}
            subscriptionCriteria={`Communication?recipient=${getReferenceString(profile as ProfileResource)}`}
            iconComponent={<IconMail />}
            onClick={() =>
              navigate(
                `/Communication?recipient=${getReferenceString(profile as ProfileResource)}&status:not=completed&_fields=sender,recipient,subject,status,_lastUpdated`
              )
            }
          />
          <NotificationIcon
            label="Tasks"
            resourceType="Task"
            countCriteria={`owner=${getReferenceString(profile as ProfileResource)}&status:not=completed&_summary=count`}
            subscriptionCriteria={`Task?owner=${getReferenceString(profile as ProfileResource)}`}
            iconComponent={<IconClipboardCheck />}
            onClick={() =>
              navigate(
                `/Task?owner=${getReferenceString(profile as ProfileResource)}&status:not=completed&_fields=subject,code,description,status,_lastUpdated`
              )
            }
          />
        </>
      }
    >
      <Suspense fallback={<Loading />}>
        <Router />
      </Suspense>
      <Footer />
    </AppShell>
  );
}